module.exports = __webpack_public_path__ + "static/media/closeBlack.63467d82.svg";